<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('exbonus.history.title-label') }}</h3>
        </div>

        <div v-if="(! transactions)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class="container center-items text-center">
            <div v-if="(transactions)">
                <div class="container center-items m-0 p-0 mt-4 ">
                    <div class="check_color_position">
                        <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>{{ $t('aube-coin.exbonus.history.aube_coin_saving') }}
                    </div>
                    <div class="w-100 overflow-auto">
                        <table class="table table-striped exbonus-table">
                            <thead>
                            <tr class="bg-primary">
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('aube-coin.exbonus.history.date-label') }}
                                </th>
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('aube-coin.exbonus.history.volume-label') }}
                                </th>
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('aube-coin.exbonus.history.remarks-label') }}
                                </th>
                                <th scope="col" class="text-center text-white border-0 text-nowrap">
                                    {{ $t('aube-coin.exbonus.history.confirmed') }}
                                </th>
                                <th scope="col" class="text-center text-white border-0 text-nowrap">
                                    {{ $t('aube-coin.exbonus.history.paid-label') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="transaction in transactions" v-bind:key="transaction.id">
                                <td class="text-left">
                                    {{ transaction.created_at | moment('YYYY/MM/DD') }} (SGT)
                                </td>
                                <td class="text-left td-amount">
                                    {{ transaction.amount | round }}
                                </td>
                                <td class="text-left">
                                    {{ transaction.remarks }}
                                </td>
                                <td class="text-center text-success">
                                    <div v-if="(transaction.status === 'confirmed') || (transaction.status === 'claimed')">
                                        <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>
                                    </div>
                                </td>
                                <td class="text-center text-success">
                                    <div v-if="(transaction.status === 'claimed')">
                                        <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- ページネーション -->
            <div class="container center-items text-center m-0 p-0 mt-5">
                <paginate v-bind:pagination="pagination" v-on:change-page="fetch(true)"></paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from './../../components/Paginate';
    import Forthing2Service from '../../services/Forthing2Service';

    export default {
        name: 'TokenBalances',

        components: {
            Paginate,
        },

        data() {
            return {
                transactions: undefined,
                pagination: {
                    total_pages: 0,
                    current_page: 1,
                    per_page: 20,
                    total: 0,
                },
            }
        },

        mounted() {
            this.fetch();
        },

        created() {
        },

        methods: {
            async fetch(scrollToTop = false) {
                const params = {
                    page: this.pagination.current_page,
                    size: this.pagination.per_page,
                };

                // トランザクション履歴を取得
                // { amount: string
                //   status: string
                //   created_at: string
                //   updated_at: string
                // }
                const txs = await Forthing2Service.getExBonusTransactions(params);

                // トランザクションを設定
                this.transactions = txs.data.data;

                // メタデータを設定
                this.pagination = txs.data.meta.pagination;

                // 場合に応じて (0, 0) にスクロールする
                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
            }
        }
    }
</script>

<style scoped>
    .exbonus-table {
        border-collapse: separate;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
    .aube_user_wallet_check_color {
        color: #450080;
    }
    .hec_saving_check_color {
        color: #00ad69;
    }
    .check_color_position {
        text-align: left;
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) {
        .td-amount {
            overflow-wrap: anywhere !important;
            width: 50px !important;
        }
    }
</style>
